var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("查询搜索")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.filterFold ? "展开筛选" : "收起筛选") +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _vm.resData
                          ? _c(
                              "el-form",
                              {
                                staticClass: "demo-form-inline",
                                attrs: { inline: true, model: _vm.form }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          "remote-method": _vm.remoteSupply,
                                          remote: "",
                                          filterable: "",
                                          placeholder: "商家"
                                        },
                                        model: {
                                          value: _vm.form.supply_id,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "supply_id", $$v)
                                          },
                                          expression: "form.supply_id"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "0" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(_vm.selections.supply, function(
                                          item,
                                          index
                                        ) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              value: item.supply_id,
                                              label: item.supply_name
                                            }
                                          })
                                        })
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "货号" },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.form.goods_no,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "goods_no", $$v)
                                        },
                                        expression: "form.goods_no"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "款号" },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.form.goods_kh,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "goods_kh", $$v)
                                        },
                                        expression: "form.goods_kh"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "SKU" },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.form.sku,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "sku", $$v)
                                        },
                                        expression: "form.sku"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          placeholder: "选择城市",
                                          multiple: ""
                                        },
                                        nativeOn: {
                                          keyup: function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            return _vm.search.apply(
                                              null,
                                              arguments
                                            )
                                          }
                                        },
                                        model: {
                                          value: _vm.form.city,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "city", $$v)
                                          },
                                          expression: "form.city"
                                        }
                                      },
                                      _vm._l(
                                        _vm.options.options_supply_city,
                                        function(item) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              value: item.value,
                                              label: item.label
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          placeholder: "选择代采组",
                                          filterable: "",
                                          clearable: ""
                                        },
                                        nativeOn: {
                                          keyup: function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            return _vm.search.apply(
                                              null,
                                              arguments
                                            )
                                          }
                                        },
                                        model: {
                                          value: _vm.form.pgid,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "pgid", $$v)
                                          },
                                          expression: "form.pgid"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { value: "0", label: "全部" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.options.options_pg_group,
                                          function(item) {
                                            return _c("el-option", {
                                              key: item.value,
                                              attrs: {
                                                value: item.value,
                                                label: item.label
                                              }
                                            })
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          placeholder: "选择代采员",
                                          filterable: "",
                                          clearable: ""
                                        },
                                        nativeOn: {
                                          keyup: function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            return _vm.search.apply(
                                              null,
                                              arguments
                                            )
                                          }
                                        },
                                        model: {
                                          value: _vm.form.pg_member_id,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "pg_member_id",
                                              $$v
                                            )
                                          },
                                          expression: "form.pg_member_id"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { value: "0", label: "全部" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.options.options_pg_member,
                                          function(item) {
                                            return _c("el-option", {
                                              key: item.value,
                                              attrs: {
                                                value: item.value,
                                                label: item.label
                                              }
                                            })
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          placeholder: "sku状态",
                                          clearable: ""
                                        },
                                        model: {
                                          value: _vm.form.sku_status,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "sku_status",
                                              $$v
                                            )
                                          },
                                          expression: "form.sku_status"
                                        }
                                      },
                                      _vm._l(_vm.skuStatus, function(item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.label,
                                            value: item.value
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          placeholder: "有无承诺回货时间",
                                          clearable: ""
                                        },
                                        model: {
                                          value: _vm.form.has_back_time,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "has_back_time",
                                              $$v
                                            )
                                          },
                                          expression: "form.has_back_time"
                                        }
                                      },
                                      _vm._l(_vm.hasBackTime, function(item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.label,
                                            value: item.value
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          placeholder: "有无触达",
                                          clearable: ""
                                        },
                                        model: {
                                          value: _vm.form.has_reach,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "has_reach", $$v)
                                          },
                                          expression: "form.has_reach"
                                        }
                                      },
                                      _vm._l(_vm.hasReach, function(item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.label,
                                            value: item.value
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "需求日期" } },
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        type: "datetimerange",
                                        "value-format": "yyyy-MM-dd",
                                        "range-separator": "至",
                                        "start-placeholder": "起始日期",
                                        "end-placeholder": "截止日期",
                                        "default-time": ["00:00:00", "23:59:59"]
                                      },
                                      model: {
                                        value: _vm.form.demanded_date,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "demanded_date",
                                            $$v
                                          )
                                        },
                                        expression: "form.demanded_date"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: { click: _vm.search }
                                      },
                                      [_vm._v("查询")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "info" },
                                        on: { click: _vm.reset }
                                      },
                                      [_vm._v("重置")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  background: "#f3f3f3",
                  height: "50px",
                  "line-height": "30px",
                  padding: "0 25px",
                  display: "flex",
                  "align-items": "center"
                }
              },
              [
                _c("div", [
                  _vm._v("\n          数据列表："),
                  _vm.resData && _vm.resData.total
                    ? _c("span", [
                        _vm._v(
                          "共" +
                            _vm._s(_vm.resData.total.spu_num) +
                            "款，" +
                            _vm._s(_vm.resData.total.total_num) +
                            "件，金额￥" +
                            _vm._s(_vm.resData.total.total_price)
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { "margin-left": "auto" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: { click: _vm.handleExport }
                      },
                      [_vm._v("\n            导出列表\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "success", size: "mini" },
                        on: { click: _vm.handleExportDetail }
                      },
                      [_vm._v("\n            导出销欠货明细\n          ")]
                    )
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _vm.resData
              ? _c(
                  "div",
                  { staticStyle: { "margin-bottom": "0" } },
                  [
                    _c(
                      "el-table",
                      {
                        ref: "multipleTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          height: "600",
                          data: _vm.resData.list,
                          "tooltip-effect": "dark",
                          border: ""
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "demanded_date",
                            label: "需求日期",
                            "show-overflow-tooltip": "",
                            align: "center",
                            width: "100"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "supply_name",
                            label: "商家名称",
                            "show-overflow-tooltip": "",
                            align: "center",
                            width: "160"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "pf_type_msg",
                            label: "城市/代采组/代采员",
                            width: "160",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("div", [_vm._v(_vm._s(scope.row.city))]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(_vm._s(scope.row.pg_name))
                                    ]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(_vm._s(scope.row.pg_member_name))
                                    ])
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1356677721
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "goods_img",
                            label: "商品图片",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "viewer",
                                            rawName: "v-viewer"
                                          }
                                        ],
                                        staticStyle: {
                                          width: "120px",
                                          height: "120px"
                                        }
                                      },
                                      _vm._l(scope.row.middle_img, function(
                                        item,
                                        index
                                      ) {
                                        return _c("img", {
                                          key: item + index,
                                          staticStyle: {
                                            width: "100%",
                                            height: "100%",
                                            "object-fit": "cover",
                                            cursor: "pointer"
                                          },
                                          attrs: { src: item }
                                        })
                                      }),
                                      0
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3576174068
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "goods_name",
                            label: "商品名称",
                            "show-overflow-tooltip": "",
                            align: "center",
                            width: "160"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "goods_no",
                            label: "货号",
                            align: "center",
                            width: "100"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "goods_kh",
                            label: "款号",
                            align: "center",
                            width: "120"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "",
                            label: "SKU/颜色/尺码",
                            align: "center",
                            width: "130"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("div", [_vm._v(_vm._s(scope.row.sku))]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(_vm._s(scope.row.co_val))
                                    ]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(_vm._s(scope.row.si_val))
                                    ])
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            190327338
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "is_sale",
                            label: "当前SKU状态",
                            align: "center",
                            width: "110"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "num",
                            label: "超3天欠货数",
                            width: "80",
                            align: "center",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function() {
                                  return [
                                    _c(
                                      "div",
                                      [
                                        _vm._v(
                                          "\n                超3天欠货数\n                "
                                        ),
                                        _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              content:
                                                "欠货包含待开单和订单欠货，商家填写货期或超过4天时则不更新",
                                              placement: "top-start"
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-question"
                                            })
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            1406795719
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "price",
                            label: "计划代采单价",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "total_price",
                            label: "总金额",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "owe_update_at",
                            label: "欠货更新时间",
                            align: "center",
                            width: "100"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "",
                            label: "触达账号/时间",
                            align: "center",
                            width: "120"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("div", [
                                      _vm._v(_vm._s(scope.row.reach_by))
                                    ]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(_vm._s(scope.row.reach_at))
                                    ])
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            829278686
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "owe_back_at",
                            label: "欠货承诺回货时间",
                            width: "140",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "",
                            label: "填写人/填写时间",
                            width: "140",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("div", [
                                      _vm._v(_vm._s(scope.row.fill_by))
                                    ]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(_vm._s(scope.row.fill_at))
                                    ])
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3089208030
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "操作",
                            width: "100",
                            align: "center",
                            fixed: "right"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "mini"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.handleDetail(scope.row)
                                          }
                                        }
                                      },
                                      [_vm._v("查看销欠货明细\n              ")]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1193694904
                          )
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.resData
              ? _c(
                  "div",
                  { staticStyle: { "text-align": "right", padding: "25px" } },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.form.page,
                        background: "",
                        layout: "total, prev, pager, next, jumper, sizes ",
                        total: _vm.total,
                        "page-size": _vm.form.pagesize,
                        "page-sizes": [20, 50, 100, 200, 500, 1000]
                      },
                      on: {
                        "update:currentPage": function($event) {
                          return _vm.$set(_vm.form, "page", $event)
                        },
                        "update:current-page": function($event) {
                          return _vm.$set(_vm.form, "page", $event)
                        },
                        "size-change": _vm.handleSizeChange,
                        "current-change": _vm.handleCurrentChange
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: { visible: _vm.currentOverdueVisible, width: "70%" },
              on: {
                "update:visible": function($event) {
                  _vm.currentOverdueVisible = $event
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function() {
                    return [
                      _c(
                        "div",
                        [
                          _vm._v("\n          入库销欠货明细\n          "),
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "dark",
                                content: "",
                                placement: "top-start"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "content",
                                  fn: function() {
                                    return [
                                      _vm._v(
                                        "\n              超3天的欠货，仅在入库销欠货时记录至此表。"
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        "\n              ① 当欠货为“待开单”时，取在【欠货更新时间】之后提交的订单；"
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        "\n              ②\n              当欠货为“订单欠货”时，取欠货id对应的订单，若被重置到待开单，则按①的规则处理。\n            "
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ])
                            },
                            [
                              _vm._v(" "),
                              _c("i", { staticClass: "el-icon-question" })
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ])
            },
            [
              _vm._v(" "),
              _vm.overdueDetail
                ? _c(
                    "div",
                    [
                      _vm.currentOverdue
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "margin-bottom": "20px"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { "margin-right": "20px" } },
                                [
                                  _vm._v(
                                    "\n            需求日期：" +
                                      _vm._s(_vm.currentOverdue.demanded_date) +
                                      "\n          "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticStyle: { "margin-right": "20px" } },
                                [
                                  _vm._v(
                                    "\n            超3天欠货：共" +
                                      _vm._s(_vm.currentOverdue.num) +
                                      "件\n          "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticStyle: { "margin-right": "20px" } },
                                [
                                  _vm._v(
                                    "\n            欠货更新时间：" +
                                      _vm._s(_vm.currentOverdue.owe_update_at) +
                                      "\n          "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticStyle: { "margin-right": "20px" } },
                                [
                                  _vm._v(
                                    "\n            承诺回货时间：" +
                                      _vm._s(_vm.currentOverdue.owe_back_at) +
                                      "\n          "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-table",
                        { attrs: { data: _vm.overdueDetail.list } },
                        [
                          _c("el-table-column", {
                            attrs: {
                              property: "planid",
                              label: "代采计划单号",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              property: "ptype_txt",
                              label: "计划类型",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              property: "woid",
                              label: "代采订单",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              property: "order_create_time",
                              label: "订单提交时间",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              property: "finish_owe_time",
                              label: "入库销欠货时间",
                              align: "center"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "text-align": "right",
                            padding: "25px"
                          }
                        },
                        [
                          _c("el-pagination", {
                            attrs: {
                              "current-page": _vm.overdueDetailPage,
                              background: "",
                              layout: "total, prev, pager, next, jumper ",
                              total: Number(_vm.overdueDetail.count),
                              "page-size": _vm.overdueDetailPageSize,
                              "page-sizes": [20, 50, 100, 200, 500, 1000]
                            },
                            on: {
                              "update:currentPage": function($event) {
                                _vm.overdueDetailPage = $event
                              },
                              "update:current-page": function($event) {
                                _vm.overdueDetailPage = $event
                              },
                              "size-change": _vm.handleDetailPageSizeChange,
                              "current-change": _vm.handleDetailPageChange
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "c_page-title" }, [
      _c("div", [_vm._v("超3天欠货货期")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5daa98a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5daa98a8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Overdue.vue
// module id = null
// module chunks = 